<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/teaP3w/tc-custom/9781460388747.jpg?1740291321067" alt="This image is the cover for the book Amish Midwife, Lancaster Courtships"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Amish Midwife, Lancaster Courtships
      </h1>
      <p class="bookDescription body article font2">
        <p><b>An Amish bachelor needs the help of a guarded midwife to care for his baby niece in this heartwarming, inspirational romance.</b></p><p><b>An Unexpected Family</b></p><p> Amish midwife Anne Stoltzfus is used to late-night visitors—but she’s shocked to find reclusive bachelor Joseph Lapp on her doorstep with a baby in his arms. Their neighborly quarrels are pushed aside when Joseph explains that his sister has left her daughter in his care—and Joseph needs Anne to be her nanny. Soon they’re bonding over baby Leah, and the love they feel for her is healing them both. When Joseph makes an offer of marriage, Anne’s painful past resurfaces and she’s unsure of what to do. But taking a chance could mean love—and family—are waiting just across the fence. </p><p><b>Lancaster Courtships: Life and love in Amish country</b></p><p> Collect all three books in the series! </p><p><i>The Amish Bride</i> by Emma Miller </p><p><i>The Amish Mother</i> by Rebecca Kertz </p><p><i>The Amish Midwife</i> by Patricia Davids </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Patricia Davids
      </h2>
      
      <p class="authorDescription body article">USA Today best-selling author Patricia Davids was born in Kansas. After forty years as an NICU nurse, Pat switched careers to become an inspirational writer. She now enjoys laid back life on a Kansas farm, spending time with her family and playing with her dog Sugar, who thinks fetch should be a twenty-four hour a day game. When not throwing a ball, Pat is happily dreaming up new stories where love and faith conquer all. Contact her at pat@patriciadavids.com.<Br><Br>&#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?174e4238